import { render, staticRenderFns } from "./UiTextInput.vue?vue&type=template&id=5d51d537&"
import script from "./UiTextInput.vue?vue&type=script&lang=js&"
export * from "./UiTextInput.vue?vue&type=script&lang=js&"
import style0 from "./UiTextInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports